import { getVrioUsers } from '@/api/users'

const state = () => ({
  meReplaceUsersCurrent: [],
  meReplaceUsersFuture: [],
  usersReplaceMeCurrent: [],
  usersReplaceMeFuture: [],
  isLoading: false,
})

const getters = {}

const mutations = {
  setMeReplaceUsersCurrent(state, users) {
    state.meReplaceUsersCurrent = users
  },
  setMeReplaceUsersFuture(state, users) {
    state.meReplaceUsersFuture = users
  },
  setUsersReplaceMeCurrent(state, users) {
    state.usersReplaceMeCurrent = users
  },
  setUsersReplaceMeFuture(state, users) {
    state.usersReplaceMeFuture = users
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
}

const actions = {
  async fetchData({ commit }) {
    if (state.isLoading) {
      return
    }
    commit('setIsLoading', true)

    await Promise.all([
      actions.getMeReplaceUsersCurrent({ commit }),
      actions.getMeReplaceUsersFuture({ commit }),
      actions.getUsersReplaceMeCurrent({ commit }),
      actions.getUsersReplaceMeFuture({ commit }),
    ])

    commit('setIsLoading', false)
  },
  async getMeReplaceUsersCurrent({ commit }) {
    const { rows } = await getVrioUsers({
      i_replace: true,
      current_period: true,
      sort: 'date_from',
    })
    commit('setMeReplaceUsersCurrent', rows)
  },
  async getMeReplaceUsersFuture({ commit }) {
    const { rows } = await getVrioUsers({
      i_replace: true,
      future_period: true,
      sort: 'date_from',
    })
    commit('setMeReplaceUsersFuture', rows)
  },
  async getUsersReplaceMeCurrent({ commit }) {
    const { rows } = await getVrioUsers({
      me_is_replaced: true,
      current_period: true,
      sort: 'date_from',
    })
    commit('setUsersReplaceMeCurrent', rows)
  },
  async getUsersReplaceMeFuture({ commit }) {
    const { rows } = await getVrioUsers({
      me_is_replaced: true,
      future_period: true,
      sort: 'date_from',
    })
    commit('setUsersReplaceMeFuture', rows)
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}
